<mat-toolbar color="primary">
  <mat-toolbar-row>
    <button type="button" mat-button class="hamburger-button" *ngIf="isHamburgerVisible$ | async" (click)="toggleLeftPanel()">
      <mat-icon class="white-icon">menu</mat-icon>
    </button>
    <ng-content></ng-content>
  </mat-toolbar-row>
</mat-toolbar>
